<div class="medikamente-section {{partnerName}}">
    <p>Bitte machen Sie konkrete Angaben zu den Medikamenten, der Dosierung, Nebenwirkungen oder Unverträglichkeiten und über welchen Zeitraum die Medikamente eingenommen wurden:</p>
    <div class="medikamente-table">
        <table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Wirkstoffmenge</th>
                    <th>Applikation</th>
                    <th></th>
                    <th colspan="4">Dosierung</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of tableData;let i=index;">
                    <tr>
                        <td rowspan="2">{{item.Name}}</td>
                        <td class="wirkstoff-td">
                            <div>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="item.Wirkstoffmenge" (change)="valueChange(item)">
                                <select class="form-control form-control-sm" [(ngModel)]="item.Unit" (change)="valueChange(item)">
                                    <ng-container *ngFor="let val of UnitList">
                                        <option [value]="val">{{val}}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </td>
                        <td class="applikation-td position-relative">
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="item.Applikation" (change)="valueChange(item)" [attr.list]="'applikation-list-'+i">
                            <datalist class="scrollbar" [attr.id]="'applikation-list-'+i">
                                <ng-container *ngFor="let val of ApplikationList | orderBy:null:false:true">
                                    <option [value]="val" (click)="chooseApplikant(val, item)">{{val}}</option>
                                </ng-container>
                            </datalist>
                        </td>
                        <td class="single-td">
                            <div class="switch-button" [class.active]="item.Single" (click)="checkboxChange(item)"></div>
                        </td>
                        <ng-container *ngIf="item.Single">
                            <td colspan="4" class="dosirung-full-td">
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="item.Dosierung" (change)="valueChange(item)">
                            </td>
                        </ng-container>
                        <ng-container *ngIf="!item.Single">
                            <td class="dosirung-td">
                                <select class="form-control form-control-sm" [(ngModel)]="item.Morgen" (change)="valueChange(item)">
                                    <ng-container *ngFor="let val of DosierungList">
                                        <option [value]="val">{{val}}</option>
                                    </ng-container>
                                </select>
                            </td>
                            <td class="dosirung-td">
                                <select class="form-control form-control-sm" [(ngModel)]="item.Mittag" (change)="valueChange(item)">
                                    <ng-container *ngFor="let val of DosierungList">
                                        <option [value]="val">{{val}}</option>
                                    </ng-container>
                                </select>
                            </td>
                            <td class="dosirung-td">
                                <select class="form-control form-control-sm" [(ngModel)]="item.Abend" (change)="valueChange(item)">
                                    <ng-container *ngFor="let val of DosierungList">
                                        <option [value]="val">{{val}}</option>
                                    </ng-container>
                                </select>
                            </td>
                            <td class="dosirung-td">
                                <select class="form-control form-control-sm" [(ngModel)]="item.Nacht" (change)="valueChange(item)">
                                    <ng-container *ngFor="let val of DosierungList">
                                        <option [value]="val">{{val}}</option>
                                    </ng-container>
                                </select>
                            </td>
                        </ng-container>
                    </tr>
                    <tr>
                        <td colspan="7">
                            <textarea type="text" class="form-control" [(ngModel)]="item.InputValue" (change)="valueChange(item)" rows="2"></textarea>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
